import React, { useEffect, useRef, useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import MemoedHOC from "@/hoc/MemoedHOC";
import {makeStyles} from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { TimePicker,message } from 'antd';
import moment from 'moment';
import { CloseCircleOutlined } from '@ant-design/icons';
import _ from "lodash"
import DeleteIcon from "../../assets/images/delete.png";
const useModalStyles = makeStyles(theme => ({
  StoreEditBusinessHoursModal: {

  },
  storeEditBusinessHoursBox: {
    "& .week-box" :{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: '1rem',
      "& .week-value": {
        cursor: "pointer",
        backgroundColor: "#f7f8fb",
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      "& .week-value-selected": {
        backgroundColor: "#00a6be",
        color: "white"
      }
    },

    "& .select-type-box":{
      height: 50,
      display: "flex"
    },

    "& .select-time-box": {
      height: 200,
      overflowY:'auto',
      width: '100%',
      backgroundColor: "#f7f8fb",
      borderRadius: 10,
      padding: "10px 20px",
      "& .title-box": {
        display: "flex",
        height: 30,
        "& .start-time-title,& .end-time-title": {
          width: "50%"
        }
      },
      "& .select-time-row": {
          display: "flex",
          "& .start-time,& .end-time": {
            width: "50%"
          },
          "& .del-icon": {
            display:"flex",
            alignItems: "center",
            cursor:"pointer"
          }
      },
      "& .error-value": {
        color: "red",
      },
      "& .add-time-box": {
        color: "#00a6be",
        cursor:"pointer"
      }
    }
  },
}));


function TranserModal({ open, list,selectWeekIndex, onConfirm, onClose,handleChangeCacheData }) {
  const { t } = useTranslation();
  // const displayWeekValueMap = [
  //   '日','一','二','三','四','五','六'
  // ]
  const displayWeekValueMap = [
    t({defaultMessage: "日"}),t({defaultMessage: "一"}),t({defaultMessage: "二"}),t({defaultMessage: "三"}),t({defaultMessage: "四"}),t({defaultMessage: "五"}),t({defaultMessage: "六"})
  ]

  const [state, setState] = useState({
    selectWeekIndexArr: [selectWeekIndex],
    updateData: _.cloneDeepWith(list[selectWeekIndex],true)
  })

  const [errorMessage, setErrorMessage] = useState([])

  const classes = useModalStyles()
  // 确定
  const handleConfirm = () => {
    // 没有选择营业类型的时候进行验证时间
    if(!state.updateData.is24Hours && !state.updateData.isRest){
      // 验证时间
      if(errorMessage.length > 0 && !_.every(errorMessage,item => !item)){
        return false
      }

      if(!state.updateData.timeList || state.updateData.timeList.length <= 0){
        message.error([t({defaultMessage: "营业时间不能为空"})])
        return false
      }
      // 验证时间段是否为空
      if(_.every(state.updateData.timeList,item => item.start.length <=0 || item.end.length <=0)){
        message.error([t({defaultMessage: "时间段不能为空"})])
        return false
      }

      // 验证时间段是否有重叠
      const timeList = state.updateData.timeList
      for(let i = 0; i < timeList.length; i++){
        for(let j = i+1; j < timeList.length; j++){
          if(moment(timeList[i].end, 'HH:mm') > moment(timeList[j].start, 'HH:mm') && moment(timeList[i].start, 'HH:mm') < moment(timeList[j].end, 'HH:mm'))
          {
            // message.error([t({defaultMessage: "时间段不能有重叠"})])
            errorMessage[j] = t({defaultMessage: "时间段和第{num}个时间段有重叠"},{num: i+1})
            setErrorMessage(errorMessage)
            setState({
              ...state,
              updateData: _.cloneDeepWith(state.updateData,true)
            })
            return false
          }
        }
      }

    }


    // 处理 list
    const uptList =list.map((item,index) => {
      if(_.includes(state.selectWeekIndexArr,index)) {
        item = {
          ...state.updateData,
          value: item.value
        }
      }
      return item
    })

    return onConfirm(uptList)
  };
  // 切换星期
  const handleSelectWeek = (index) => {
    const selectWeekIndexArr = state.selectWeekIndexArr
    // 表示不存在，进行添加
    // 表示存在，进行取消
    if(_.includes(state.selectWeekIndexArr,index)) {
      setState({
        ...state,
         selectWeekIndexArr: selectWeekIndexArr.filter(item => item !== index)
      })
      return
    }
    selectWeekIndexArr.push(index)
    setState({
      ...state,
      selectWeekIndexArr: selectWeekIndexArr
    })

    // setState({
    //   ...state,
    //   selectWeekIndex: index
    // })
  }

  // 是否24小时营业
  const handleChange24Hours = (event) => {
    const updateData = state.updateData
    updateData.is24Hours = event.target.checked
    updateData.isRest = false
    setState({
      ...state,
      updateData: updateData
    });
  };
  // 是否休息
  const handleChangeRest = (event) => {
    const updateData = state.updateData
    updateData.is24Hours = false
    updateData.isRest = event.target.checked
    setState({
      ...state,
      updateData: updateData
    });
  };
  // 切换开始时间
  const handleChangeStart = (event,index) => {
    const updateData = state.updateData
    updateData.timeList[index].start = event ? event.format('HH:mm') : '00:00'
    setState({
      ...state,
      updateData: updateData
    });
    checkTime(index)
  }
  // 切换结束时间
  const handleChangeEnd = (event,index) => {
    const updateData = state.updateData
    updateData.timeList[index].end = event ? event.format('HH:mm') : '00:00'
    setState({
      ...state,
      updateData: updateData
    });
    checkTime(index)
  }

  const checkTime = (index) => {
    const updateData = state.updateData
    const start = updateData.timeList[index].start
    const end = updateData.timeList[index].end
    if(start.length <=0){
      errorMessage[index] = t({defaultMessage: "开始时间不能为空"})
      setErrorMessage(errorMessage)
      return false
    }
    if(end.length <=0){
      errorMessage[index] = t({defaultMessage: "结束时间不能为空"})
      setErrorMessage(errorMessage)
      return false
    }
    if(start >= end){
      errorMessage[index] = t({defaultMessage: "结束时间不可以早于开始时间"})
      setErrorMessage(errorMessage)
      return false
    }

    if(errorMessage[index]){
      const i = errorMessage.findIndex(item => item === errorMessage[index])
      errorMessage.splice(i,1)
      setErrorMessage(errorMessage)
    }
    return true
  }

  // 添加时间
  const handleAddTime = () => {
    const updateData = state.updateData
    updateData.timeList.push({
      start: "00:00",
      end: "00:00"
    })
    setState({
      ...state,
      updateData: updateData
    });
  }

  // 删除时间
  const handleDelTime = (index) => {
    if(errorMessage[index]){
      const i = errorMessage.findIndex(item => item === errorMessage[index])
      errorMessage.splice(i,1)
      setErrorMessage(errorMessage)
    }
    const updateData = state.updateData
    updateData.timeList.splice(index,1)
    setState({
      ...state,
      updateData: updateData
    });
  }

  useEffect(()=>{
    // handleChangeCacheData(state.list)
  },[state])

  // useEffect(() => {
  //   if (!open) {
  //     setSelected([]);
  //   }
  // }, [open]);
  return (
    <Modal
      title={t({ defaultMessage: "营业时间" })}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      className={classes.StoreEditBusinessHoursModal}
    >
      <div className={classes.storeEditBusinessHoursBox}>
        <div className={`week-box`}>
          {
            _.map(list,(item,index)=>{
              return <div key={index} className={`week-value ${_.includes(state.selectWeekIndexArr,index) ? ' week-value-selected' : '' }`} onClick={ () => { handleSelectWeek(index) }}>{displayWeekValueMap[index]}</div>
            })
          }
        </div>
        <div className={`select-type-box`}>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.updateData.is24Hours}
                onChange={handleChange24Hours}
                name="is24Hours"
                color="primary"
                size="small"
              />
            }
            label={t({defaultMessage:"24h营业" })}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={state.updateData.isRest}
                onChange={handleChangeRest}
                name="isRest"
                color="primary"
                size="small"
              />
            }
            label={t({defaultMessage:"休息" })}
          />
        </div>

        <div className={`select-time-box`}>
          {
            (!state.updateData.is24Hours && !state.updateData.isRest) &&
            <>
              <div className={`title-box`}>
                <div className={`start-time-title`}>{t({defaultMessage:"开始时间" })}</div>
                <div className={`end-time-title`}>{t({defaultMessage:"结束时间" })}</div>
              </div>
              {
                _.map(state.updateData.timeList,(item,index) => {
                  return <div style={{paddingBottom: 10}} key={index}>
                      <div className={`select-time-row`}>
                      <div className={`start-time`}>
                        <TimePicker value={moment(item.start, 'HH:mm')} popupClassName={`storeTimePopupClass`} format={`HH:mm`} onChange={(event) => handleChangeStart(event, index)}/>
                      </div>
                      <div className={`end-time`}>
                        <TimePicker value={moment(item.end, 'HH:mm')} popupClassName={`storeTimePopupClass`} format={`HH:mm`} onChange={(event) => handleChangeEnd(event, index)}/>
                      </div>
                      <div className={`del-icon`} onClick={()=>{handleDelTime(index)}}>
                        {/*<DeleteForeverOutlinedIcon />*/}
                        <img src={DeleteIcon} alt="delete" style={{width: 14,height: 14}}/>
                        {/*<CloseCircleOutlined style={{"fontSize": "1.2rem","color": "red","cursor":"pointer"}}/>*/}
                      </div>
                    </div>
                    {errorMessage[index] && <div className={`error-value`}>{errorMessage[index]}</div>}
                  </div>
                })
              }
              <div className={`add-time-box`} onClick={()=>{handleAddTime()}}>{t({defaultMessage:"添加营业时间段" })}</div>
            </>
          }

        </div>
      </div>
    </Modal>
  );
}

export default React.memo(TranserModal);
